module.exports = __webpack_public_path__ + "static/bluebib-db8c604ea5f98b3d83568b30095b7b15.png";